import { Component, OnInit } from "@angular/core";
import { Router } from "@angular/router";
import { authenticationService } from "@app/login/auth.service";
import { TeamsService } from "../shared/teams.service";
import { Permissions } from "@models/permissions.enum";

@Component({
  selector: "app-teamslist",
  templateUrl: "./teamslist.component.html",
  styleUrls: ["./teamslist.component.css"],
})
export class TeamslistComponent implements OnInit {
  teams: any[] = [];
  cols: any = [];

  filters = {
    name: "",
    driversList: "",
  }

  newButtonAction: any = this.onClickNew;
  newButtonOptions: any = [
    {
        label: 'New Client',
        command: () => {
            this.onClickNew();
        }
    }
  ];

  constructor(
    private router: Router,
    private authService: authenticationService,
    private teamsService: TeamsService
  ) {}

  ngOnInit(): void {
    this.cols = [
      { field: "name", header: "Name" },
      { field: "driversList", header: "Drivers" },
    ];

    this.teamsService.getTeamsList().subscribe({
      next: (teams) => {
        this.teams = teams.map((team) => ({
          ...team,
          driversList: team.drivers
            .map((driver: any) => `${driver.name} ${driver.lastName}`)
            .join(", "),
        }));
      },
      error: (error) => console.error(error),
    });
  }

  hasPermission(permissionName: string) {
    const permission = Permissions[permissionName];
    return this.authService.hasPermission(permission);
  }

  viewDetail(team: any) {
    this.router.navigate(["/teams/", team.id]);
  }

  onClickNew() {
    this.router.navigate(["/teams/new"]);
  }

  loadData(){
    return this.teamsService.getTeamsList();
  }

  excelGeneration(selectedColumns: any[], selectedTrips: any[], filters: any, selectAll: boolean) {
    const colNames = selectedColumns.map((col) => col.header);
    const colFields = selectedColumns.map((col) => col.field);


    this.teamsService.getTeamsList().subscribe({
      next: (teams) => {
        this.teams = teams.map((team) => ({
          ...team,
          driversList: team.drivers
            .map((driver: any) => `${driver.name} ${driver.lastName}`)
            .join(", "),
        }));
      },
      error: (error) => console.error(error),
    });
    const observable = this.teamsService.getTeamsList();
    observable.subscribe((res: any) => {
      const teams = res.map((team) => ({
        ...team,
        driversList: team.drivers
          .map((driver: any) => `${driver.name} ${driver.lastName}`)
          .join(", "),
      }));
      const values = teams.filter((team: any) => {
        return (
          (selectAll || selectedTrips.includes(team.id)) &&
          (!this.filters.name || team.name?.toLowerCase().includes(this.filters.name.toLowerCase())) &&
          (!this.filters.driversList || team.driversList?.toLowerCase().includes(this.filters.driversList.toLowerCase()))
        );
      });

      //need this function because typeof returns 'boolean' for primitive booleans and 'object' for Boolean objects
      function isBoolean(val) {
        return val === false || val === true;
      }

      let plainRecords = values.map((trip) => {
        let tripRecord = [];
        for (const field of colFields) {
          const datatype = typeof trip[field];
          if (datatype === "string") trip[field] = trip[field].replace(/\r?\n|\r/g, "").toUpperCase();
          if (trip[field] && trip[field].toString().includes(",")) {
            tripRecord.push(`"${trip[field]}"`);
          } else if (isBoolean(trip[field])) {
            //for some reason data is coming in mixed as primitive booleans and Boolean objects.
            //the conditional after this prints empty strings for undefineds but also puts empty string instead of false
            tripRecord.push(trip[field] ? "TRUE" : "FALSE");
          } else {
            tripRecord.push(trip[field] || "");
          }
        }
        return tripRecord;
      });
      plainRecords.unshift(colNames);
      let CsvString = "";
      for (const rowItem of plainRecords) {
        CsvString += rowItem.join(",") + "\r\n";
      }
      CsvString = "data:application/csv," + encodeURIComponent(CsvString);
      let x = document.createElement("A");
      x.setAttribute("href", CsvString);
      x.setAttribute("download", "teams_list_" + new Date().toLocaleDateString() + ".csv");
      document.body.appendChild(x);
      x.click();
    });
  }
}
